// src/components/Market.js
import React from 'react';
import { useGame } from '../contexts/GameContext';
import Card from './Card';
import './Market.css';

function Market({ market, disabled }) {
  const { selectedCards, selectMarketCard } = useGame();

  if (!market || market.length === 0) {
    return <div className="market empty">市场为空</div>;
  }

  return (
    <div className="market">
      {market.map((card, index) => (
        <Card
          key={index}
          card={card}
          selected={selectedCards.market.includes(index)}
          onClick={() => !disabled && selectMarketCard(index)}
          disabled={disabled}
        />
      ))}
    </div>
  );
}

export default Market;
